// import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import Paths from './paths';
import { useInitProvider } from 'providers/InitProvider';
import { NOTIFICATION_PATH, NOTIFICATION_READ_PATH } from './config';

export function useQueryNotifications(options) {
  const { dump } = useInitProvider();

  const url = `${Paths.join(
    dump.shell.ws.domain,
    `${NOTIFICATION_PATH}/${dump.shell.ws.token}`,
  )}`;

  const queryInfo = useQuery(
    'useQueryNotifications',
    () => {
      console.log(`useQueryNotifications usequery axios.get(${url})`)
      return axios.get(url)
    },
    options,
  );

  return queryInfo;
}

export function useNotificationsMarkAsRead() {
  const { dump } = useInitProvider();

  const url = `${Paths.join(
    dump.shell.ws.domain,
    `${NOTIFICATION_READ_PATH}`,
  )}`;

  const mutation = useMutation({
    mutationFn: (body) => {
      console.log(`useNotificationsMarkAsRead mutationFn axios.put(${url})`)
      return axios.put(url, body);
    },
  });

  return mutation;
}
